import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PlacementForm from '../components/PlacementForm';

const RequestPlacement = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('placement_form.title')} | Tap'nGrab</title>
        <meta name="description" content={t('placement_form.subtitle')} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${t('placement_form.title')} | Tap'nGrab`} />
        <meta property="og:description" content={t('placement_form.subtitle')} />
        <meta property="og:url" content={`https://tapngrab.ca/${i18n.language === 'fr' ? 'fr/' : ''}request-placement`} />
        <meta property="og:image" content="https://tapngrab.ca/images/smart-store.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content={i18n.language === 'fr' ? 'fr_CA' : 'en_CA'} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${t('placement_form.title')} | Tap'nGrab`} />
        <meta name="twitter:description" content={t('placement_form.subtitle')} />
        <meta name="twitter:image" content="https://tapngrab.ca/images/smart-store.png" />
        <link rel="canonical" href="https://tapngrab.ca/request-placement" />
        <link rel="alternate" hreflang="fr" href="https://tapngrab.ca/fr/request-placement" />
        <link rel="alternate" hreflang="en" href="https://tapngrab.ca/request-placement" />
      </Helmet>

      <div className="text-slate-800 bg-white">
        <Header />
        
        {/* Hero Section */}
        <section className="hero-grad py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-slate-900 sm:text-5xl lg:text-6xl">
                {t('placement_form.title')}
              </h1>
              <p className="mt-6 text-lg text-slate-600 max-w-2xl mx-auto">
                {t('placement_form.subtitle')}
              </p>
            </div>
          </div>
        </section>

        {/* Criteria Section */}
        <section className="bg-white py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-slate-900 mb-8">
                {t('placement_form.criteria.title')}
              </h2>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {t('placement_form.criteria.list', { returnObjects: true }).map((criteria, index) => (
                  <div key={index} className="rounded-2xl border bg-white p-6 chip">
                    <p className="text-sm text-slate-600">{criteria}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Form Section */}
        <section className="bg-slate-50 py-16 sm:py-24">
          <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
            <div className="rounded-2xl border bg-white p-8 chip">
              <PlacementForm />
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default RequestPlacement;
